import React from 'react'

import {
  CommentIcon,
  CommentOutlinedIcon,
} from 'components/common/custom-icons'
import DefaultButton from './DefaultButton'
import { useTranslation } from 'react-i18next'

const CommentButton = ({
  selected,
  onPress,
}: {
  selected: boolean
  onPress: { (): void }
}) => {
  const { t } = useTranslation()
  
  return (
    <DefaultButton
      title={t('comment')}
      icon={<CommentIcon style={{ marginRight: 6 }} height={24} width={24} />}
      hoverIcon={
        <CommentOutlinedIcon
          style={{ marginRight: 6 }}
          height={24}
          width={24}
        />
      }
      selected={selected}
      onPress={onPress}
    />
  )
}

export default CommentButton
